import type { InjectionKey } from "vue";

/**
 * @description Callback that selects the entire TipTap document so the following
 * `ghl-text-editor` toolbar action applies globally. Provided by `text-editor/index.vue`.
 */
export type FormSurveyRtePrepareSelectAll = () => void;

/**
 * @description Vue `provide` / `inject` key for {@link FormSurveyRtePrepareSelectAll}.
 * Used by the rich text shell and footer popovers that render outside the toolbar capture wrapper.
 */
export const formSurveyRtePrepareSelectAllKey: InjectionKey<FormSurveyRtePrepareSelectAll> =
  Symbol("formSurveyRtePrepareSelectAll");
